module.exports = __webpack_public_path__ + "static/media/visit-logo-white.b527a1dc.svg";